import React from "react";
import { TextField, ActionButton, ErrorText } from "../../atoms";
import T from "prop-types";
import { FaEye, FaEyeSlash } from "react-icons/fa";
export const LoginForm = ({
  onClick,
  onChangeEmail,
  onChangePassword,
  validateEmail,
  errorMessage,
  email,
  password,
  isSubmit,
  togglePassword,
  isVisible,
  changePage
}) => (
  <>
    <form onSubmit={onClick} className="center">
      <div className="bottomSpace">
        <TextField
          placeholder="Email"
          mainWrapCls={"loginWrapCls"}
          onChange={(e) => onChangeEmail(e)}
          isError={
            (email === "" && isSubmit) || (isSubmit && !validateEmail(email))
              ? true
              : false
          }
          errorText={
            email === "" && isSubmit
              ? "Please enter your email"
              : isSubmit && !validateEmail(email)
                ? "Please enter a valid email"
                : null
          }
        />
      </div>
      <div className="passwordLogin">
        <TextField
          placeholder="Password"
          icon={
            isVisible ? (
              <FaEye className="textfield-icon" onClick={togglePassword} />
            ) : (
              <FaEyeSlash className="textfield-icon" onClick={togglePassword} />
            )
          }
          type={isVisible ? "password" : "text"}
          isVisible={isVisible}
          togglePassword={togglePassword}
          mainWrapCls={"loginWrapCls"}
          onChange={(e) => onChangePassword(e)}
          isError={password === "" && isSubmit ? true : false}
          errorText={
            password === "" && isSubmit ? "Please enter your password" : null
          }
        />
      </div>
      {
        isSubmit && errorMessage !== "" && password !== "" ? (
          <div className="errorTexttwrap">
            <ErrorText text={errorMessage} />
          </div>
        ) : null
      }
      <div className="space-top center">
        <ActionButton text="LOGIN" type="submit"  />
      </div>
      <div onClick={()=>changePage(2)} className="space-top click" style={{color:'#E3031F',fontSize:'14px'}}>Forgot your password?</div>
    </form>
  </>
);

LoginForm.T = {
  onClick: T.func,
};

LoginForm.defaultProps = {
  onClick: null,
};
